import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FlexRateModal } from "app/pages/Booking/Quotation/FlexRate/FlexRateModal";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";
import { showFlexRatesModal } from "app/pages/Booking/Quotation/quotationActionCreators";
import { calculateQuoteBaseAndExtrasTotal } from "app/pages/Booking/bookingSelectors";

const mapStateToProps = state => {
	const booking = state.booking;

	return {
		total: calculateQuoteBaseAndExtrasTotal(state),
		vendor: state.vendor,
		nbPassengers: booking.passengers ? booking.passengers.length : 0,
		quotation: state.quotation,
		isOpened: state.quotation.isFlexRatesModalOpened,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ updateBooking, showFlexRatesModal }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FlexRateModal);
